<template>
	<div>
		<p v-scroll-revealer="defaultScroll">Baby blue looks good on me.</p>
		<p v-scroll-revealer="hoverScroll">Baby blue looks good on me.</p>
		<p v-scroll-revealer="triggerScroll"></p>
		<div class="test" :class="target">Test</div>
	</div>
</template>

<script>
import { ScrollRevealer } from '@/directives/Revealer/ScrollRevealer';

export default {
	name: 'ScrollRevealer',
	directives: {
		ScrollRevealer,
	},

	props: {
		target: { type: String, required: false, default: '-triggerScroll' },
	},

	methods: {
		defaultScroll: function (evt, el) {
			if (window.scrollY > 1) {
				el.setAttribute('style', 'opacity: 1');
			}
		},
		hoverScroll: function (evt, el) {
			if (window.scrollY >= el.offsetTop) {
				el.setAttribute('style', 'opacity: 1');
			}
		},
		triggerScroll: function (evt, el) {
			if (window.scrollY >= el.offsetTop) {
				document
					.querySelector('.' + this.target)
					.setAttribute('style', 'opacity: 1');
			}
		},
	},
};
</script>

<style scoped>
p {
	height: 25vh;
	opacity: 0;
}
.test {
	opacity: 0;
}
</style>
